import React from 'react';
import { Chart } from 'primereact/chart';
import { useSelector, useDispatch } from 'react-redux';
import { loadDailyNewUsersAsync, selectDailyNewUsers } from '../dashboardSlice';
import { ChartCard } from './ChartCard';

// Duas linhas: novos usuários (o User nasce na primeira compra) e
// assinaturas adicionais do mesmo e-mail (renovação, upgrade ou recompra).
const SERIES = [
    {
        key: 'newUsers',
        label: 'Novos usuários (primeira assinatura)',
        borderColor: '#7E57C2',
        backgroundColor: 'rgba(126, 87, 194, 0.1)'
    },
    {
        key: 'additionalSubscriptions',
        label: 'Assinaturas adicionais',
        borderColor: '#26A69A',
        backgroundColor: 'rgba(38, 166, 154, 0.1)'
    }
];

export const DailyNewUsersChart = () => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector(selectDailyNewUsers);

    const prepareData = () => {
        const sortedData = Array.isArray(data)
            ? [...data].sort((a, b) => new Date(a.date) - new Date(b.date))
            : [];

        return {
            labels: sortedData.map(item => item.date),
            datasets: SERIES.map(series => ({
                label: series.label,
                data: sortedData.map(item => item[series.key] ?? 0),
                borderColor: series.borderColor,
                backgroundColor: series.backgroundColor,
                tension: 0.4,
                fill: true
            }))
        };
    };

    return (
        <ChartCard
            title="Aquisições por dia"
            loading={status === 'loading'}
            error={error}
            onReload={() => dispatch(loadDailyNewUsersAsync())}
        >
            <Chart type="line" data={prepareData()} />
        </ChartCard>
    );
};
